import {RegistroEntrenador } from '../../system/RegistroEntrenador/RegistroEntrenador';
import CustomForm from '../../lib/FormValidator/Form/CustomForm'
import { RegistroEntrenadorTitulo } from '../../system/RegistroEntrenadorTitulo/RegistroEntrenadorTitulo'
import { RegistroEntrenadorTituloAssertions } from '../../system/RegistroEntrenadorTitulo/RegistroEntrenadorTituloAssertions'
class RegistroEntrenadorTituloForm extends CustomForm {
    protected constructor(
    ret_id: string,
    ret_reid: string,
    ret_titulo: string,
    ret_otorgado_por: string,
    ret_docente: boolean,
    ret_anio_egreso: number | null,
    ret_imagen_titulo: File | null)
    {const tia = RegistroEntrenadorTituloAssertions.build()
    super("RegistroEntrenadorTitulo", tia)
    this.addInputAsserted('ret_id', ret_id)
    this.addInput('ret_reid', ret_reid)
    this.addInput('ret_titulo', ret_titulo)
    this.addInput('ret_otorgado_por', ret_otorgado_por)
    this.addInput('ret_docente', ret_docente)
    this.addInput('ret_anio_egreso', ret_anio_egreso)
    this.addInput('ret_imagen_titulo', ret_imagen_titulo)
}

private static build( ret_id: string,
ret_reid: string,
ret_titulo: string,
ret_otorgado_por: string,
ret_docente: boolean ,
ret_anio_egreso: number | null,
ret_imagen_titulo: File | null) {
    return new this( ret_id,
    ret_reid,
    ret_titulo,
    ret_otorgado_por,
    ret_docente ,
    ret_anio_egreso,
    ret_imagen_titulo)
}

static initialize() {
    return this.build( 'new',
    '',
    '',
    '',
    false ,
    null,
    null)
}

static with(entity: RegistroEntrenadorTitulo) {
    return this.build(entity.getId(),
    entity.getReid(),
    entity.getTitulo(),
    entity.getOtorgadoPor(),
    entity.getDocente(),
    entity.getAnioEgreso(),
    entity.getImagenTitulo())
}

getIdInput() { return this.getInputByName('ret_id') }

getReidInput() { return this.getInputByName('ret_reid') }

getTituloInput() { return this.getInputByName('ret_titulo') }

getOtorgadoPorInput() { return this.getInputByName('ret_otorgado_por') }

getDocenteInput() { return this.getInputByName('ret_docente') }

getAnioEgresoInput() { return this.getInputByName('ret_anio_egreso') }

getImagenTituloInput() { return this.getInputByName('ret_imagen_titulo') }

toRegistroEntrenadorTitulo(): RegistroEntrenadorTitulo {
    return RegistroEntrenadorTitulo.createFrom(
    this.getIdInput().getValue(),
    this.getReidInput().getValue(),
    this.getTituloInput().getValue(),
    this.getOtorgadoPorInput().getValue(),
    this.getDocenteInput().getValue() ,
    this.getAnioEgresoInput().getValue() ,
    this.getImagenTituloInput().getValue())
}

}

export default RegistroEntrenadorTituloForm
